<template>
  <div class="my-home">
    <div class="login">
      <div class="login-title">主办登录</div>
      <div class="login-form">
        <div class="form-filed">
          <i class="icon iconfont icon-shouji"></i>
          <input :class="phoneTip ? 'errlight' : ''" type="number" class="form-input" placeholder="请输入手机号" v-model="phone" />
        </div>
        <div class="form-filed code">
          <i class="icon iconfont icon-ziyuan"></i>
          <input :class="codeTip ? 'errlight' : ''" class="form-input" placeholder="请输入验证码" v-model="code" />
          <div class="form-filed-txt">
            <span v-if="timer" style="color:#999;">{{ count || 0 }}s</span>
            <span @click="send" style="color:#f85b0f;" v-else>获取验证码</span>
          </div>
        </div>
        <div class="form-filed-error">{{ error }}</div>
        <button @click="submitHandle" class="button-round">登录</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      timer: null,
      count: 0,
      code: "",
      phone: "",
      error: "",
      phoneTip: false,
      codeTip: false,
    };
  },
  components: {},
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfoDetails;
    },
  },
  methods: {
    ...mapMutations({
      setRoomId: "setRoomId",
      setToken: "setToken",
      setRole: "setRole",
      setUserInfo: "setUserInfo",
    }),
    ...mapActions({
      getUrlQuery: "getUrlQuery",
      sendCode: "login/sendCode",
      validateCode: "login/validateCode",
      hostLogin: "login/hostLogin",
      getHostInfo: "login/getHostInfo",
    }),
    async send() {
      let validPhone = this.validPhone(this.phone);
      if (!validPhone) {
        this.phoneTip = true;
        return;
      }
      this.$toast.loading({
        message: "发送中...",
        forbidClick: true,
      });
      this.downTime();
      let res = await this.sendCode({
        phone: this.phone,
      });
      if (res && res.Data.result) {
        this.$toast.success("已发送");
      } else {
        this.$toast.fail("发送失败！");
      }
    },
    //倒计时
    downTime() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        const timer = setInterval(() => {
          let count = this.count;
          if (count > 0 && count <= TIME_COUNT) {
            count--;
            this.count = count;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
        this.timer = timer;
      }
    },
    async submitHandle() {
      let validPhone = this.validPhone(this.phone);
      if (!validPhone) {
        this.phoneTip = true;
        return;
      }
      let validCode = this.validCode(this.code);
      if (!validCode) {
        this.codeTip = true;
        return;
      }
      let req = {
        phone: this.phone,
        code: this.code,
      };
      let result = await this.validateCode(req);
      if (result && result.Data.result) {
        let form = {
          grant_type: "password",
          scope: "",
          login_type: "phone",
          user_type: "host",
          phonenumber: this.phone,
        };
        let bool = await this.hostLogin(form);
        if (bool) {
          this.$toast.success("登录成功！");
          this.setToken(bool.access_token);
          let hostInfo = await this.getHostInfo();
          if (hostInfo && hostInfo.Data) {
            this.setRole(1); // 角色为主办
            this.setUserInfo(hostInfo.Data);
            // wx.redirectTo({
            //   url: `/pages/live/main?roomid=${this.roomid}`
            // });
          }
        } else {
          this.$toast.fail("登录失败！");
        }
      } else {
        this.$toast.fail("验证码错误！");
        return;
      }
    },
    validPhone(value) {
      if (!value) {
        this.error = "请输入手机号码";
        return false;
      } else if (/^[1][0-9]{10}$/.test(value)) {
        this.error = "";
        this.phoneTip = false;
        return true;
      } else {
        this.error = "请输入正确的手机号";
        return false;
      }
    },
    validCode(value) {
      if (!value) {
        this.error = "请输入手机验证码";
        return false;
      } else {
        this.error = "";
        this.codeTip = false;
        return true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.login {
  width: 100%;
  overflow: hidden;
  background-image: url(data:image/png;base64,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);
  background-size: contain;
  background-repeat: no-repeat;
}

.login-bg {
  width: 100%;
  height: 100vh;
  position: absolute;
  z-index: 99;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0 auto;
  background-color: #000;
}

.login-title {
  padding: 0.8rem 0.3rem 0;
  font-size: 0.4rem;
  color: #333;
  margin-bottom: 1rem;
}

.login-form {
  padding: 0 0.3rem;
}

.form-filed {
  height: 0.88rem;
  margin-bottom: 0.3rem;
  position: relative;
}
.form-filed.code {
  margin: 0;
}
.form-input {
  width: 100%;
  display: block;
  height: 0.88rem;
  line-height: 0.88rem;
  background-color: #fff;
  border-radius: 0.44rem;
  border: solid 1px #d9d9d9;
  padding: 0 0.92rem;
}

// .form-input:hover,
// .form-input:active {
//   color: #f85b0f;
// }

.errlight {
  border: 1px solid #f85b0f;
}

.form-filed i {
  width: 0.92rem;
  height: 0.92rem;
  line-height: 0.92rem;
  text-align: center;
}

.form-filed .iconfont {
  color: #999;
  font-size: 0.52rem;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.form-filed-txt {
  font-size: 0.3rem;
  // color: #f85b0f;
  position: absolute;
  right: 0.42rem;
  top: 50%;
  transform: translateY(-50%);
  height: 0.92rem;
  line-height: 0.92rem;
  z-index: 2;
}

.form-filed-error {
  height: 0.4rem;
  line-height: 1;
  margin: 0.2rem 0;
  font-size: 0.24rem;
  color: #ff0000;
  padding-left: 0.4rem;
}

.button-round {
  color: #fff;
  display: block;
  width: 100%;
  line-height: 0.88rem;
  font-size: 0.36rem;
  border-color: transparent;
  border-radius: 0.88rem;
  background: linear-gradient(to right, #ff512f, #f09819);
}
</style>
